export default "__VITE_ASSET__DEA3smgc__"